import { Model } from "pinia-orm";
import { Attr, Str, Uid, BelongsToMany, BelongsTo } from "pinia-orm/decorators";
import User from "./User";
import UserGroup from "./UserGroup";

export default class Group extends Model {
  static entity = "groups";

  @Uid() declare id: string;
  @Str("") declare displayName: string;
  @Str("") declare description: string;
  @Attr(null) declare userId: string | null;
  @Attr(null) declare ownerId: string | null;
  @BelongsToMany(() => User, () => UserGroup, 'group_id', 'user_id') declare members: User[]
  @BelongsTo(() => User, 'ownerId') declare owner: User | null

}
